<mat-card class="editRatesCard">
  <mat-card-header>
    <mat-card-title> Set Up Rates </mat-card-title>
    <mat-card-subtitle> Set Up Rates</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form">
      <mat-tab-group class="matTabGroup" mat-align-tabs="start" [(selectedIndex)]="selectedTabIndex">
        <mat-tab class="tab" label="Billable">
          <ng-template mat-tab-label>
            <mat-icon fontSet="material-symbols-outlined">lab_profile</mat-icon> Billable</ng-template
          >
          <div class="group" formGroupName="billable">
            <div *ngFor="let key of objectKeys(billableControls)">
              <ul>
                <li>
                  <div class="rates">
                    <p>{{ key }} :</p>
                    <mat-form-field class="inputRate">
                      <mat-label>Rate</mat-label>
                      <input matInput type="number" [formControlName]="key" />
                    </mat-form-field>
                    <button mat-icon-button color="warn" (click)="deleteBillable(key)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="showAddForm.billable">
              <div *ngFor="let pair of keyValuePairsTab1; let i = index">
                <ul>
                  <li>
                    <div class="addForm">
                      <mat-form-field class="inputCPT">
                        <input matInput [formControl]="pair.key" placeholder="CPT code" />
                      </mat-form-field>
                      <mat-form-field class="inputRate">
                        <input matInput [formControl]="pair.value" placeholder="Rate" />
                      </mat-form-field>
                      <button mat-icon-button color="warn" (click)="cancel('billable', i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <button class="question-create-answer" mat-button color="accent" (click)="showForm('billable')">
              <mat-icon>add_circle_outline</mat-icon>
              Add
            </button>
          </div>
        </mat-tab>
        <mat-tab label="Medicare">
          <ng-template mat-tab-label>
            <mat-icon fontSet="material-symbols-outlined">lab_profile</mat-icon> Medicare
          </ng-template>
          <div class="group" formGroupName="medicare">
            <div *ngFor="let key of objectKeys(medicareControls)">
              <ul>
                <li>
                  <div class="rates">
                    <p>{{ key }} :</p>
                    <mat-form-field class="inputRate">
                      <mat-label>Rate</mat-label>
                      <input matInput type="number" [formControlName]="key" />
                    </mat-form-field>
                    <button mat-icon-button color="warn" (click)="deleteMedicare(key)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="showAddForm.medicare">
              <div *ngFor="let pair of keyValuePairsTab2; let i = index">
                <ul>
                  <li>
                    <div class="addForm">
                      <mat-form-field class="inputCPT">
                        <input matInput [formControl]="pair.key" placeholder="CPT code" />
                      </mat-form-field>
                      <mat-form-field class="inputRate">
                        <input matInput [formControl]="pair.value" placeholder="Rate" />
                      </mat-form-field>
                      <button mat-icon-button color="warn" (click)="cancel('medicare', i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <button class="question-create-answer" mat-button color="accent" (click)="showForm('medicare')">
              <mat-icon>add_circle_outline</mat-icon>
              Add
            </button>
          </div>
        </mat-tab>
        <mat-tab label="Stripe">
          <ng-template mat-tab-label>
            <mat-icon fontSet="material-symbols-outlined">lab_profile</mat-icon> Stripe
          </ng-template>
          <div class="group" formGroupName="stripe">
            <div *ngFor="let key of objectKeys(stripeControls)">
              <div class="rates-stripe" [formGroupName]="key">
                <div class="stripeCode">
                  <h3>{{ key }}</h3>
                  <button mat-icon-button color="warn" (click)="deleteStripe(key)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <div class="stripe">
                  <mat-form-field>
                    <mat-label>Price Id</mat-label>
                    <input matInput formControlName="price_id" placeholder="Price Id" />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Active</mat-label>
                    <mat-select formControlName="active" aria-placeholder="Active">
                      <mat-option [value]="true">True</mat-option>
                      <mat-option [value]="false">False</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div *ngIf="showAddForm.stripe">
              <div class="addFormStripe" *ngFor="let pair of keyValuePairsTab3; let i = index">
                <div class="stripeCodeInput">
                  <mat-form-field class="active">
                    <input matInput [formControl]="pair.key" placeholder="CPT code" />
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="cancel('stripe', i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <mat-form-field class="inputPriceId">
                  <input matInput [formControl]="pair.value" placeholder="Price Id" />
                </mat-form-field>
              </div>
            </div>
            <button class="question-create-answer" mat-button color="accent" (click)="showForm('stripe')">
              <mat-icon>add_circle_outline</mat-icon>
              Add
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div *ngIf="selectedTabIndex === 0" class="actionsButton">
      <button mat-raised-button color="primary" type="button" (click)="save('billable')">Save</button>
      <button mat-raised-button color="default" type="button" (click)="close()">Close</button>
    </div>
    <div *ngIf="selectedTabIndex === 1" class="actionsButton">
      <button mat-raised-button color="primary" type="button" (click)="save('medicare')">Save</button>
      <button mat-raised-button color="default" type="button" (click)="close()">Close</button>
    </div>
    <div *ngIf="selectedTabIndex === 2" class="actionsButton">
      <button mat-raised-button color="primary" type="button" (click)="save('stripe')">Save</button>
      <button mat-raised-button color="default" type="button" (click)="close()">Close</button>
    </div>
  </mat-card-actions>
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</mat-card>
